<div class="dialog-header" fxLayout="row" fxLayoutAlign="flex-end flex-start">
  <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content>
  <tg-post-item [post]="data.post" (edit)="editPost($event)" (editMsg)="editPostMsg($event)"></tg-post-item>
</mat-dialog-content>
